import {InputText} from "primereact/inputtext";
import faqImg from "../../assets/img/faq/imgPeople-FAQ.png";
import React, {useEffect, useState} from "react";
import PinjamanKaryawan from "../../assets/img/icon/ic-pinjaman-karyawan.svg";
import PinjamanUsaha from "../../assets/img/icon/ic-pinjaman-usaha.svg";
import PerusahaanMitra from "../../assets/img/icon/ic-perusahaan-mitra.svg";
import Pendanaan from "../../assets/img/icon/ic-pendanaan.svg";
import Akun from "../../assets/img/icon/ic-account.svg";
import GeneralInfo from "../../assets/img/icon/ic-general-info.svg";
import {getDanai} from "../util/ajax";
import {Accordion, AccordionTab} from "primereact/accordion";

function Index() {
    const [question, setQuestion] = useState('');
    const [questions, setManyQuestion] = useState([]);

    useEffect(() => {
        if (question.trim() !== "") {
            getDanai(
                process.env.REACT_APP_CMS + `?question=${question}`,
                function (resp) {
                    setManyQuestion(resp);
                },
                function () {}
            );
        }
    }, [question]);
    const handleChange = (e) => {
        setQuestion(e.target.value);
    };

    const handleCategoryClick = (category) => {
        getDanai(
            process.env.REACT_APP_CMS + `?question=${category}`,
            function (resp) {
                setManyQuestion(resp);
            },
            function () {}
        );
    };

    return (
        <div>
            <div className="mt-16 hero-bg-faq">
                <div className="faq">
                    <div className="page-navigation">
                        <ul className="breadcrumb">
                            <li><a href="\">Beranda</a></li>
                            <li className="final">FAQ</li>
                        </ul>
                    </div>
                    <div className="card-hero">
                        <div className="text">
                            <div className="row-title">
                                <h4>Frequently Asked Question</h4>
                                <p>Bagaimana kami dapat membantu Anda? <br/>Cari jawaban dari pertanyaan yang sering
                                ditanyakan disini:</p>
                                <InputText id='question' className='input-search' value={question}
                                           onChange={handleChange}/>
                            </div>
                        </div>
                        <div className="image">
                            <img src={faqImg} alt="faq"/>
                        </div>
                    </div>
                </div>
            </div>
            <div className="faq-category">
                {Array.isArray(questions) && questions.length > 0 && (
                    <div className="answer-container">
                        <h4 className="text-center m-0 text-[#252525]">Hasil Pencarian</h4>
                        <Accordion multiple activeIndex={[0]}>
                            {questions.map((q) => (
                                <AccordionTab header={q.scenarioTitle}>
                                    <div
                                        className="m-0"
                                        dangerouslySetInnerHTML={{__html: q.positiveReply}}
                                    />
                                </AccordionTab>
                            ))}
                        </Accordion>
                    </div>
                )}
                <h4 className="text-center m-0 text-[#252525]">Kategori Topik</h4>
                <div className="faq-category-container">
                    <a onClick={() => handleCategoryClick("pinjaman")} className="faq-category-list" href={() => false}>
                        <img src={PinjamanKaryawan} alt="Pinjaman Karyawan"/>
                        <div className="explanation-text">
                            <p className="font-bold">Pinjaman Karyawan</p>
                            <p>Informasi seputar pinjaman karyawan <em>(consumptive loan)</em> di Danai.id</p>
                        </div>
                    </a>
                    <a onClick={() => handleCategoryClick("pinjaman")} className="faq-category-list" href={() => false}>
                        <img src={PinjamanUsaha} alt="Pinjaman Usaha"/>
                        <div className="explanation-text">
                            <p className="font-bold">Pinjaman Usaha</p>
                            <p>Informasi seputar pinjaman usaha <em>(productive loan)</em> di Danai.id</p>
                        </div>
                    </a>
                    <a onClick={() => handleCategoryClick("pemberi")} className="faq-category-list" href={() => false}>
                        <img src={Pendanaan} alt="Pendanaan"/>
                        <div className="explanation-text">
                            <p className="font-bold">Pendanaan</p>
                            <p>Informasi seputar pendanaan di Danai.id</p>
                        </div>
                    </a>
                    <a onClick={() => handleCategoryClick("mitra")} className="faq-category-list" href={() => false}>
                        <img src={PerusahaanMitra} alt="Perusahaan Mitra"/>
                        <div className="explanation-text">
                            <p className="font-bold">Perusahaan Mitra</p>
                            <p>Informasi seputar bagaimana menjadi Perusahaan Mitra untuk dapat menikmati layanan Danai.id</p>
                        </div>
                    </a>
                    <a onClick={() => handleCategoryClick("akun")} className="faq-category-list" href={() => false}>
                        <img src={Akun} alt="Akun"/>
                        <div className="explanation-text">
                            <p className="font-bold">Akun</p>
                            <p>Informasi seputar akun baik sebagai <em>Borrower</em> (Penerima Dana) maupun <em>Lender</em> (Pemberi Dana) di Danai.id</p>
                        </div>
                    </a>
                    <a onClick={() => handleCategoryClick("a")} className="faq-category-list" href={() => false}>
                        <img src={GeneralInfo} alt="Informasi Umum"/>
                        <div className="explanation-text justify-center">
                            <p className="font-bold">Informasi Lainnya</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Index;
